import React from "react";
import SkillBubbleChart from "../SkillIndexCircle/SkillBubbleChart";

const MAX_SKILL_BUBBLES = 10;

const emptySkillData = [
  { SkillName: "No Data", Percentage: 0 },
  { SkillName: "No Data", Percentage: 0 },
  { SkillName: "No Data", Percentage: 0 },
];

const getSkillName = (skill) =>
  skill?.SkillName || skill?.name || skill?.label || skill?.Skills?.SkillName || "Skill";

const getSkillPercent = (skill) =>
  Math.max(0, Math.floor(Number(skill?.Percentage || skill?.value || skill?.SkillPercent) || 0));

const normalizeSkills = (skills = []) =>
  skills
    .slice(0, MAX_SKILL_BUBBLES)
    .map((skill) => ({
      SkillName: getSkillName(skill),
      Percentage: getSkillPercent(skill),
    }))
    .sort((a, b) => b.Percentage - a.Percentage);

export default function SkillIndex({ data }) {
  const skillList = Array.isArray(data) ? data : [];
  const chartData = skillList.length ? normalizeSkills(skillList) : emptySkillData;

  return <SkillBubbleChart data={chartData} />;
}
